// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__S9kAJ","header__wrapper":"style_header__wrapper__jSMqW","header-logo":"style_header-logo__rYdQE","header__code":"style_header__code__JRK_1"};